import {
  LayoutDashboard,
  Building2,
  GitFork,
  UserCog,
  ShieldCheck,
  ScrollText,
} from 'lucide-react'
import type { NavigationSection } from './navigationConfig'

export const organizationAdminNavigationConfig: NavigationSection[] = [
  {
    title: 'MAIN',
    items: [
      {
        label: 'Dashboard',
        path: '/organization-admin/dashboard',
        permission: 'dashboard:view',
        icon: LayoutDashboard,
      },
    ],
  },
  {
    title: 'ORGANIZATION & BRANCH SETUP',
    items: [
      {
        label: 'Manage Organization',
        path: '/organization-admin/manage-organization',
        permission: 'organization:view',
        icon: Building2,
      },
      {
        label: 'Manage Branches',
        path: '/organization-admin/manage-branches',
        permission: 'branches:view',
        icon: GitFork,
      },
    ],
  },
  {
    title: 'USER & ROLE MANAGEMENT',
    items: [
      {
        label: 'User Management',
        path: '/organization-admin/user-management',
        permission: 'user-management:view',
        icon: UserCog,
      },
      {
        label: 'Role Management',
        path: '/organization-admin/role-management',
        permission: 'role-management:view',
        icon: ShieldCheck,
      },
    ],
  },
  {
    title: 'AUDIT & COMPLIANCE',
    items: [
      {
        label: 'Audit Logs',
        path: '/organization-admin/audit-logs',
        permission: 'audit-logs:view',
        icon: ScrollText,
      },
    ],
  },
]
